<template>
  <section>
    <SoWidget
      v-for="(vehicleUsage, index) in vehicleUsages"
      :key="index"
      class="mb-5"
    >
      <div
        class="usage-estimate__vehicle-select d-flex align-center justify-space-between"
      >
        <SoSelect
          v-model="vehicleUsage.vehicle"
          :items="electricVehicleOptions"
          placeholder="Select vehicle type"
          type="simple"
          class="usage-estimate__select"
          label="What type car is it?"
        />
        <SoButton type="icon" icon="minus" @click="removeVehicle(index)" />
      </div>
      <SoSlider
        v-model="vehicleUsage.milesPerYear"
        :label="`Approx. miles per year: ${vehicleUsage.milesPerYear}`"
        :min="0"
        :max="30000"
        :step="100"
      />
    </SoWidget>

    <SoButton
      title="Add another vehicle"
      class="mb-6"
      prepend-icon="plus"
      @click="addVehicle"
    />
  </section>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoSelect from "@/components/formControls/SoSelect.vue"
  import SoSlider from "@/components/SoSlider.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { IElectricVehicleUsage } from "@/services/UsageEstimationService/types"
  import { UsageEstimationService } from "@/services/UsageEstimationService"

  export default defineComponent({
    components: {
      SoButton,
      SoSelect,
      SoSlider,
      SoWidget,
    },
    props: {
      modelValue: {
        type: Object as PropType<IElectricVehicleUsage[]>,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      vehicleUsages: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
      electricVehicleOptions() {
        return UsageEstimationService.getElectricVehicleTypes().map(
          (vehicle) => ({
            value: vehicle,
            title: vehicle.name,
          }),
        )
      },
    },
    methods: {
      addVehicle() {
        this.vehicleUsages = [
          ...this.vehicleUsages,
          { vehicle: null, milesPerYear: 0 },
        ]
      },
      removeVehicle(removalIndex) {
        this.vehicleUsages = this.vehicleUsages.filter(
          (_, index) => index !== removalIndex,
        )
      },
    },
  })
</script>

<style scoped>
  .usage-estimate__select {
    max-width: 300px;
    margin-bottom: 8px;
  }
  .usage-estimate__vehicle-select {
    line-height: 1.6;
  }
</style>
